export enum StandardWorkingDayMethod {
  Fixed = "FIXED",
  Calendar = "ACTUAL_CALENDAR",
  EmployeeWorkingShift = "WORKING_SHIFT",
}

export enum StandardWorkingDayObject {
  Department = "DEPARTMENT",
  JobTitle = "JOB_TITLE",
  WorkLevel = "WORK_LEVEL",
  EmployeeType = "EMPLOYEE_TYPE",
  Employee = "EMPLOYEE",
}

export type StandardWorkingDay = {
  id: string;
  status: number;
  orgId: number;
  effectiveFrom: string;
  calculateMethod: string;
  applicableObject: string;
  workingDayTypeFixed: {
    objectCode: string;
    objectName: string;
    workingDay: number;
    workingHour: number;
  }[];
  workingDayEmployeeFixed: {
    empId: string;
    workingDay: number;
    workingHour: number;
    isNew?: boolean;
  }[];
  workingDayTypeActualCalendar: {
    dayOfWeek: number;
    value: number;
    active: boolean;
  }[];
};
